import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Card, DatePicker, Form } from 'antd'
import { MailOutlined } from '@ant-design/icons'

import apiConfig from '../../../config/apiConfig'

const SCB_GMAIL_PATH = '/th/admin/scb_gmail'

const ScbGmailImport = () => {
    const { t } = useTranslation('documents')
    const [afterDate, setAfterDate] = useState(null)

    const handleStart = () => {
        const query = new URLSearchParams({ after_date: afterDate.format('YYYY/MM/DD') })
        window.open(`${apiConfig.apiBase}${SCB_GMAIL_PATH}?${query}`, '_blank', 'noopener,noreferrer')
    }

    return (
        <Card
            style={{ marginBottom: 20 }}
            title={
                <Card.Meta
                    title={t('scbGmailImport.title')}
                    description={t('scbGmailImport.description')} />
            }>
            <Form layout="inline">
                <Form.Item label={t('scbGmailImport.afterDate')} required>
                    <DatePicker value={afterDate} onChange={setAfterDate} />
                </Form.Item>
                <Form.Item>
                    <Button icon={<MailOutlined />} disabled={!afterDate} onClick={handleStart}>
                        {t('scbGmailImport.start')}
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    )
}

export default ScbGmailImport
